module.exports = __webpack_public_path__ + "img/chest.3597c19b.png";